import React from "react";

const VisionBand = () => {
  return (
    <section
      id="vision"
      className="py-16 bg-ink text-paper relative overflow-hidden"
    >
      <div
        className="absolute inset-0 opacity-[0.06]"
        aria-hidden="true"
        style={{
          backgroundImage:
            "radial-gradient(circle at 1px 1px, #4CAF50 1px, transparent 0)",
          backgroundSize: "32px 32px",
        }}
      />
      <div className="relative max-w-5xl mx-auto px-6 text-center">
        <p className="text-[11px] font-semibold uppercase tracking-widest text-paper-400 mb-4">
          Where this is going
        </p>
        <p className="font-display text-2xl md:text-4xl font-bold text-paper leading-tight">
          To be Europe's leading company for{" "}
          <span className="text-brand-mint">human mobility data</span>.
        </p>
        <p className="mt-5 text-sm md:text-base text-paper-400 max-w-2xl mx-auto">
          Neutral, multi-operator, transparent. The infrastructure layer that
          makes mobility data usable for everyone who needs it.
        </p>
      </div>
    </section>
  );
};

export default VisionBand;
